<template>
  <WorkPackageSubPageModule :workpackage="workpackage" :isMobile="isMobile" :location="location" :loading="loading"
    :is_create_screen="is_create" :save_btn_loading="save_btn_loading" :header_options="[
      { description: 'Delete', icon: 'bin-delete', show: !is_create && isEditMode, delete_btn_loading: delete_btn_loading },
    ]" :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex" @headerBack="navigateBack()"
    @headerCancel="navigateBack()" @headerSave="createElement()" @clickHeaderDelete="deleteElement()">
    <template #header-rightside>
    </template>
    <template #sort-buttons>

    </template>

    <template #body>
      <!-- NAME -->
      <DisableableInputField class="mt-2 mb-2" :label="'Name'" :value="element.name"
        :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex" @change="updateElementValue('name', $event)" />

      <!-- DESCRIPTION -->
      <TextArea :value="element.description" :label="'Description'" :placeholder="`Describe the element...`"
        :max_char_count="isEditMode ? 300 : ''" :height="170" :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
        :is_disabled="!isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Add', entity: 'Elements', twp: workpackage.id })"
        @change="updateElementValue('description', $event)" />

      <!-- HEIGHT -->
      <DisableableInputField class="mt-2 mb-2" input_type="number" :label="'Count'" v-model="amount"
      :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
      :foreground_color="workpackage_fg_hex" @change="updateAmount($event)" />

      <!-- WorkStep -->
      <DropDownOutlinedFlat v-if="is_create && !parseInt($route.params.content_id)" :label="'WorkStep'" :options="tworkstep_options" :value="element.tworkstep"
      :is_disabled="!isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Add', entity: 'Elements', twp: workpackage.id })"
      :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex"
      @change="updateElementValue('tworkstep', parseInt($event))" style="width: 100%;" />

      <!-- IFC TYPE -->
      <DropDownOutlinedFlat :label="'IFC.type'" :options="getIfcElementTypes" :value="element.ifc_type"
        :is_disabled="!isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Add', entity: 'Elements', twp: workpackage.id })"
        :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex"
        @change="updateElementValue('ifc_type', $event)" style="width: 100%;" />

      <!-- IFC PARENT WRAPPER -->
      <DropDownOutlinedFlat v-if="is_create" :label="'PARENT.wrapper'" :options="wrapper_options"
        :value="element.parent_wrapper"
        :is_disabled="!isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Add', entity: 'Elements', twp: workpackage.id })"
        :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex"
        @change="updateElementValue('parent_wrapper', $event)" style="width: 100%;" />

      <!-- BASE ATTRIBUTES -->
      <div style="display: flex; width: 100%;">
        <TText value="Attributes" font_weight="400" size="10" :color="workpackage_fg_hex" style="margin: 0 5px;" />
      </div>

      <div class="element-base-attributes">
        <!-- HEIGHT -->
        <DisableableInputField class="mt-2 mb-2 element-base-attributes-item" :label="'Height'" :value="element.height"
          :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
          :foreground_color="workpackage_fg_hex" @change="updateElementValue('height', parseFloat($event))" />

        <!-- FLOOR AREA -->
        <DisableableInputField class="mt-2 mb-2 element-base-attributes-item" :label="'Floor Area'"
          :value="element.floor_area" :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
          :foreground_color="workpackage_fg_hex" @change="updateElementValue('floor_area', parseFloat($event))" />
      </div>
      <div class="element-base-attributes">
        <!-- LENGTH -->
        <DisableableInputField class="mt-2 mb-2 element-base-attributes-item" :label="'Length'" :value="element.length"
          :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
          :foreground_color="workpackage_fg_hex" @change="updateElementValue('length', parseFloat($event))" />

        <!-- WIDTH -->
        <DisableableInputField class="mt-2 mb-2 element-base-attributes-item" :label="'Width'" :value="element.width"
          :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
          :foreground_color="workpackage_fg_hex" @change="updateElementValue('width', parseFloat($event))" />
      </div>
      <div class="element-base-attributes">
        <!-- VOLUME -->
        <DisableableInputField class="mt-2 mb-2 element-base-attributes-item" :label="'Volume'" :value="element.volume"
          :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
          :foreground_color="workpackage_fg_hex" @change="updateElementValue('volume', parseFloat($event))" />

        <!-- PERIMETER -->
        <DisableableInputField class="mt-2 mb-2 element-base-attributes-item" :label="'Perimeter'"
          :value="element.perimeter" :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
          :foreground_color="workpackage_fg_hex" @change="updateElementValue('perimeter', parseFloat($event))" />
      </div>
      <div class="element-base-attributes">
        <!-- SURFACE -->
        <DisableableInputField class="mt-2 mb-2 element-base-attributes-item" :label="'Surface'"
          :value="element.surface" :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
          :foreground_color="workpackage_fg_hex" @change="updateElementValue('surface', parseFloat($event))" />

        <!-- LATERAL SURFACE -->
        <DisableableInputField class="mt-2 mb-2 element-base-attributes-item" :label="'Lateral Surface'"
          :value="element.lateral_surface" :is_disabled="!(isEditMode || is_create)"
          :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex"
          @change="updateElementValue('lateral_surface', parseFloat($event))" />
      </div>
      <div class="element-base-attributes">
        <!-- WEIGHT -->
        <DisableableInputField class="mt-2 mb-2 element-base-attributes-item" :label="'Weight'" :value="element.weight"
          :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
          :foreground_color="workpackage_fg_hex" @change="updateElementValue('weight', parseFloat($event))" />

        <!-- SIDE AREA -->
        <DisableableInputField class="mt-2 mb-2 element-base-attributes-item" :label="'Side Area'"
          :value="element.side_area" :is_disabled="!(isEditMode || is_create)" :background_color="workpackage_bg_hex"
          :foreground_color="workpackage_fg_hex" @change="updateElementValue('side_area', parseFloat($event))" />
      </div>
      <ButtonOutlined
        v-if="is_create"
        value="PROJECT.structure"
        icon="project-structure"
        class="mb-4"
        :color="workpackage_fg_hex"
        style="width: 98%;"
        @buttonClicked="$router.push({ name: 'ProjectStructure' })" 
      />

    </template>
  </WorkPackageSubPageModule>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'

import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
import TText from '@/components/Taktify/TText.component.vue';
// import TIcon from '@/components/Taktify/TIcon.component.vue';
import TextArea from '@/components/WorkPackageWIP/TextArea.component.vue';
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';


export default {
  components: {
    WorkPackageSubPageModule,
    TText,
    // TIcon,
    DisableableInputField,
    DropDownOutlinedFlat,
    TextArea,
    ButtonOutlined
  },

  mixins: [
    WorkPackageReworkMixin
  ],

  props: [
    'location',
    'nav_back',
    'step_type',
  ],

  data: () => ({
    new_element: {
      name: 'New Element',
      description: 'New dummy element.',
      height: 0,
      floor_area: 0,
      perimeter: 0,
      length: 0,
      width: 0,
      volume: 0,
      surface: 0,
      lateral_surface: 0,
      weight: 0,
      side_area: 0,
      ifc_type: { text: 'IFCWALL', value: 'IFCWALL' },
      parent_wrapper: { text: '', value: '' },
      tworkstep: -1
    },
    amount: 1,
  }),

  created() {
    let promises = [];
    let self = this;

    promises.push(self.requestUObject({
      url: [
        { projects: self.project_id },
        { projectstructure: '' }
      ]
    }));

    if (self.is_create) {
      promises.push(self.requestUObject({
        url: [
          { projects: self.project_id },
          { trains: self.train_id },
          { taktareas: self.taktarea_id },
          { showWithEntitiesNormalized: '' }
        ]
      }));
    }

    Promise.all(promises).then(() => {
      self.new_element.parent_wrapper = self.wrapper_options[0];
      self.new_element.tworkstep = self.tworkstep_options[0].value;
      if (self.is_create) {
        let ta = self.$store.state.Ultra.taktareas[self.taktarea_id];
        self.requestUObject({
          url: [
            { elements: ta.elements[0] },
            { showWithEntitiesNormalized: '' }

          ],
          url_prefix: `/projects/${self.project_id}/projectstructure`,
        }).then(() => {
          let ref_el = self.$store.state.Ultra.elements[ta.elements[0]];
          for (let index = 0; index < self.wrapper_options.length; index++) {
            if (
              self.wrapper_options[index].type === ref_el.parent.type &&
              self.wrapper_options[index].id === ref_el.parent.id
            ) {
              self.new_element.parent_wrapper = self.wrapper_options[index];
              // text: self.wrapper_options[index].name,
              // value: self.wrapper_options[index].id
              break;
            }
          }
        })
      }
    })
  },

  mounted() {
  },

  watch: {
    element_id() {
      // if (!this.is_create) {
      // this.loadData();
      // }
    },
    workpackage_id() {
      this.$router.push({ name: `${this.location}WorkPackageelements` })
    }
  },

  computed: {
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObject',
    ]),
    ...mapGetters('ProjectStructure', [
      'getIfcElementTypes',
      'getProjectWrapper',
    ]),

    wrapper_options() {
      let options = this.getProjectWrapper({ wrapper_to_check: [{ type: 'projects', id: this.project_id }] });
      if (options.length === 0) {
        options.push({
          name: 'New Site',
          text: 'New Site',
          value: -1,
          id: -1,
          type: 'sites'
        });
      }
      return options;
    },

    element_id() {
      return this.$route.params.element_id;
    },

    element() {
      if (!this.is_create) {
        if (this.$store.state.Ultra[`elements`][this.element_id]) {
          let el = JSON.parse(JSON.stringify(this.$store.state.Ultra[`elements`][this.element_id]));
          el.ifc_type = { text: el.ifc_type, value: el.ifc_type };
          return el;
        } else {
          return { element: '', id: this.element_id };
        }
      } else {
        return this.new_element;
      }
    },
    tworkstep_options(){
      let tworksteps = this.getUObjects({type: `tworksteps`, ids: this.workpackage[`tworksteps`]})

      let options = [];
      for (let index = 0; index < tworksteps.length; index++) {
        options.push({
          text: tworksteps[index].text,
          value: tworksteps[index].id,
        })
      }

      return options;
    }
  },

  methods: {
    ...mapActions('Ultra', [
      'updateUObjectRelations',
      'requestUObject',
      'createUObject',
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbarBIMProcess',
      // 'requestSnackbarDelete',
      'requestSnackbarCreate',
    ]),

    updateElementValue(key, val) {
      if (this.is_create) {
        this.new_element[key] = val;
      } else {
        this.requestSnackbarBIMProcess({
          action: 'update',
          project_id: this.project_id,
          tworkstep: this.element.tworksteps[0],
          update: {
            [key]: val
          },
          conditions: [
            // TODO: other conditions?
            { ifc_type: { value: this.element.ifc_type.value, operator: 'equals' } }
          ]
        })

        this.updateUObject({
          url: [
            { elements: this.element.id }
          ],
          url_prefix: `/projects/${this.project_id}/projectstructure`,
          update: {
            [key]: val
          }
        });
      }
    },

    navigateBack() {
      this.$router.push({ name: this.nav_back });
    },

    deleteElement() {
      this.delete_btn_loading = true,
        this.deleteUObject({
          url: [
            { elements: this.element.id }
          ],
          url_prefix: `/projects/${this.project_id}/projectstructure`,
        }).then(() => {
          this.delete_btn_loading = false,
            this.navigateBack()
        })
    },

    createElement() {
      let self = this;
      self.save_btn_loading = true;
      new Promise((resolve) => {
        if (self.new_element.parent_wrapper.value === -1) {
          // need to create wrapper
          self.createUObject({
            url: [
              { sites: '' },
              { showWithEntitiesNormalized: '' }
            ],
            url_prefix: `/projects/${this.project_id}/projectstructure`,
            u_object: { parent: { type: 'projects', id: this.project_id }, type: 'sites', name: 'New Site', description: 'New Site.', order_index: 5 }
          }).then(wrapper => {
            resolve(this.$store.state.Ultra.sites[wrapper]);
          });
        } else {
          // resolve...
          resolve(self.new_element.parent_wrapper);
        }
      }).then(wrapper => {
        let element_payload = JSON.parse(JSON.stringify(this.new_element));
        delete element_payload['parent_wrapper'];
        element_payload.type = 'elements';
          // parent
          element_payload['parent'] = {
            type: wrapper.type,
            id: wrapper.id
          };
          // add taktarea
          element_payload['add#taktareas'] = [parseInt(this.taktarea_id)];
          // add workstep

          if(parseInt(this.$route.params.content_id)){
            element_payload.tworkstep = this.content_id;
          }

          element_payload['add#tworksteps'] = [element_payload.tworkstep];
          
          // rewrite IFC TYPE
          if (this.new_element.ifc_type.value) {
            element_payload.ifc_type = this.new_element.ifc_type.value;
          } else {
            element_payload.ifc_type = this.new_element.ifc_type;
          }

          this.requestSnackbarCreate({
            url: [
              { projects: this.project_id },
              { trains: this.train_id },
              { taktareas: this.taktarea_id },
              { twaggons: this.twaggon_id },
              { tworkpackages: this.workpackage_id },
              { tworksteps: element_payload.tworkstep },
              { showWithEntitiesNormalized: '' }
            ],
            reference: { type: 'tworksteps', id: element_payload.tworkstep, additional_target_entity: 'taktareas' },
            u_object: this.$store.state.Ultra.tworksteps[element_payload.tworkstep],
            e_object: element_payload,
            bulk_bulk: {amount: this.amount},
            is_elements: true
          }).then(() => {
            let element_payload_bulk = [];
            for (let index = 0; index < this.amount; index++) {
              element_payload_bulk.push(element_payload);
            }

            let wrapper_ids = [];
            for (let index = 0; index < this.amount; index++) {
              wrapper_ids.push(wrapper.id);
            }

            self.createUObject({
              url: [
                {[wrapper.type]: wrapper.id},
                { elements: '' }, 
                { createbulk: ''},
                { showWithEntitiesNormalized: '' }
              ],
              url_prefix: `/projects/${this.project_id}/projectstructure`,
              u_object: {
                 elements: element_payload_bulk,
                 updates: []
              },
              bulk: {
                parents: {
                  [wrapper.type]: wrapper_ids
                },
                targets: {
                  elements: element_payload_bulk
                },
              },
            }).then(created_el => {
              let element_ids = [];
              for (let index = 0; index < this.amount; index++) {
                element_ids.push(created_el + index);
              }

              self.updateUObjectRelations({
                url: [
                  { projects: this.project_id },
                  { trains: this.train_id },
                  { taktareas: this.taktarea_id },
                  { twaggons: this.twaggon_id },
                  { tworkpackages: this.workpackage_id },
                  { tworksteps: element_payload.tworkstep }
                ],
                target_type: 'elements',
                target_ids: element_ids,
                action: 'add',
                bidirectional: true,
                local: true
              });

              self.updateUObjectRelations({
                url: [
                  { projects: this.project_id },
                  { trains: this.train_id },
                  { taktareas: this.taktarea_id }
                ],
                target_type: 'elements',
                target_ids: element_ids,
                action: 'add',
                bidirectional: false,
                local: true
              });
              self.save_btn_loading = false;
              this.navigateBack();
            })
          });
      });
    },

    loadData() {
      this.loading = true;
      let promises = [];
      Promise.all(promises)
        .then(() => {
          this.loading = false;
        });
    },
    updateAmount(amount){
      this.amount = amount
    }
  },
}
</script>
<style>
.element-base-attributes {
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.element-base-attributes-item {
  max-width: 48% !important;
  min-width: 48% !important;
}
</style>
